import { action, createRequestTypes } from './base';

export const paymentActionTypes = {
  GET_PAYMENTS_OUTGOING: createRequestTypes('GET_PAYMENTS_OUTGOING'),
  GET_APPROVED_ONLINE_PAYMENTS: createRequestTypes('GET_APPROVED_ONLINE_PAYMENTS'),
  GET_PAYMENT_OUTGOING_BY_ID: createRequestTypes('GET_PAYMENT_OUTGOING_BY_ID'),
  CREATE_PAYMENTS_OUTGOING: createRequestTypes('CREATE_PAYMENTS_OUTGOING'),
  UPDATE_PAYMENTS_OUTGOING: createRequestTypes('UPDATE_PAYMENTS_OUTGOING'),
  CREATE_AND_LINK_PAYMENT: createRequestTypes('CREATE_AND_LINK_PAYMENT'),
  LINK_PAYMENT: createRequestTypes('LINK_PAYMENT'),
  UNLINK_PAYMENT: createRequestTypes('UNLINK_PAYMENT'),
  DELETE_PAYMENT_OUTGOING: createRequestTypes('DELETE_PAYMENT_OUTGOING'),
  UPDATE_PAYMENT_OUTGOING_STATUS: createRequestTypes('UPDATE_PAYMENT_OUTGOING_STATUS'),
  UPDATE_PAYMENT_OUTGOING_WORKFLOW: createRequestTypes('UPDATE_PAYMENT_OUTGOING_WORKFLOW'),
  UNLINK_PO_ADVANCE_PAYMENT: createRequestTypes('UNLINK_PO_ADVANCE_PAYMENT'),
  DOWNLOAD_PAYMENT_OUTGOING: createRequestTypes('DOWNLOAD_PAYMENT_OUTGOING'),

};

/**
 * PaymentOutgoingActions class
 *
 * @param payload
 * @param callback
 */
class PaymentOutgoingActions {
  /**
   * @param {*} page
   * @param {*} limit
   * @param {*} tenantId
   * @param tenantSellerId
   * @param {*} tenantRoleId
   * @param {*} approvalStatus
   * @param status
   * @param {*} paymentId
   * @param {*} paymentType
   * @param {*} searchKeyword
   * @return
   */
  getPaymentsOutgoing = (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId, isExpense, appliedPaymentType) => action(paymentActionTypes.GET_PAYMENTS_OUTGOING.REQUEST, {
    page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId, isExpense, appliedPaymentType,
  });

  /**
   * @param getPaymentsOutgoingLoading
   * @return {{type: *}}
   */
  getPaymentsOutgoingLoading = (getPaymentsOutgoingLoading) => action(paymentActionTypes.GET_PAYMENTS_OUTGOING.LOADING, {
    getPaymentsOutgoingLoading,
  });

  /**
   *
   * @param {*} paymentOutgoing
   * @return
   */
  getPaymentsOutgoingSuccess = (paymentOutgoing) => action(paymentActionTypes.GET_PAYMENTS_OUTGOING.SUCCESS, {
    paymentOutgoing,
  });

  /**
   * @param tenantId
   * @param paymentId
   * @param callback
   * @return {{type: *}}
   */
  getPaymentOutgoingById = (tenantId, paymentId, callback, paymentType) => action(paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.REQUEST, {
    tenantId,
    paymentId,
    callback,
    paymentType,
  })

  /**
   *
   * @param getPaymentOutgoingByIdLoading
   * @return {{type: *}}
   */
  getPaymentOutgoingByIdLoading = (getPaymentOutgoingByIdLoading) => action(paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.LOADING, {
    getPaymentOutgoingByIdLoading,
  })

  /**
   *
   * @param selectedPaymentOutgoing
   * @return {{type: *}}
   */
  getPaymentOutgoingByIdSuccess = (selectedPaymentOutgoing) => action(paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.SUCCESS, {
    selectedPaymentOutgoing,
  })

  /**
 * @param {*} page
 * @param {*} limit
 * @return
 */
  getApprovedOnlinePayments = (page, limit, tenantId, tenantRoleId) => action(paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.REQUEST, {
    page, limit, tenantId, tenantRoleId,
  });

  /**
  * @param getApprovedOnlinePaymentsLoading
  * @return {{type: *}}
  */
  getApprovedOnlinePaymentsLoading = (getApprovedOnlinePaymentsLoading) => action(paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.LOADING, {
    getApprovedOnlinePaymentsLoading,
  });

  /**
  *
  * @param {*} approvedPayments
  * @return
  */
  getApprovedOnlinePaymentsSuccess = (approvedPayments) => action(paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.SUCCESS, {
    approvedPayments,
  });

  /**
   *
   * @type {{type: *}}
   */
  createPaymentsOutgoing = (payload, callback) => action(paymentActionTypes.CREATE_PAYMENTS_OUTGOING.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param createPaymentsOutgoingLoading
   * @param createTenantLoading
   * @return {{type: *}}
   */
  createPaymentsOutgoingLoading = (createPaymentsOutgoingLoading) => action(paymentActionTypes.CREATE_PAYMENTS_OUTGOING.LOADING, {
    createPaymentsOutgoingLoading,
  });

  /**
   *
   * @type {{type: *}}
   */
  updatePaymentOutgoing = (payload, callback) => action(paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param createPaymentsOutgoingLoading
   * @param updatePaymentsOutgoingLoading
   * @param createTenantLoading
   * @return {{type: *}}
   */
  updatePaymentsOutgoingLoading = (updatePaymentsOutgoingLoading) => action(
    paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.LOADING, {
    updatePaymentsOutgoingLoading,
  },
  );

  /**
  *
  * @type {{type: *}}
  */
  updatePaymentsOutgoingStatus = (payload, callback) => action(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.REQUEST, {
    payload,
    callback,
  });

  /**
* @param updatePaymentsOutgoingStatusLoading
* @return {{type: *}}
*/
  updatePaymentsOutgoingStatusLoading = (updatePaymentsOutgoingStatusLoading) => action(
    paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.LOADING, {
    updatePaymentsOutgoingStatusLoading,
  },
  );

  /**
   *
   * @type {{type: *}}
   */
  deletePaymentOutgoing = (paymentId, callback) => action(paymentActionTypes.DELETE_PAYMENT_OUTGOING.REQUEST, {
    paymentId,
    callback,
  });

  /**
   *
   * @param {*} deletePaymentOutgoingLoading
   * @return
   */
  deletePaymentOutgoingLoading = (deletePaymentOutgoingLoading) => action(
    paymentActionTypes.DELETE_PAYMENT_OUTGOING.LOADING, {
    deletePaymentOutgoingLoading,
  },
  );

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createAndLinkPayment = (payload, callback) => action(paymentActionTypes.CREATE_AND_LINK_PAYMENT.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param createAndLinkPaymentLoading
   * @return {{type: *}}
   */
  createAndLinkPaymentLoading = (createAndLinkPaymentLoading) => action(
    paymentActionTypes.CREATE_AND_LINK_PAYMENT.LOADING, {
    createAndLinkPaymentLoading,
  },
  );

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  linkPayment = (payload, callback) => action(paymentActionTypes.LINK_PAYMENT.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param linkPaymentLoading
   * @return {{type: *}}
   */
  linkPaymentLoading = (linkPaymentLoading) => action(
    paymentActionTypes.LINK_PAYMENT.LOADING, {
    linkPaymentLoading,
  },
  );

  /**
   * @param {*} payload
   * @param grnPaymentId
   * @param {*} callback
   * @return
   */
  unLinkPayment = (grnPaymentId, callback) => action(paymentActionTypes.UNLINK_PAYMENT.REQUEST, {
    grnPaymentId,
    callback,
  });

  /**
   * @param unLinkPaymentLoading
   * @param linkPaymentLoading
   * @return {{type: *}}
   */
  unLinkPaymentLoading = (unLinkPaymentLoading) => action(
    paymentActionTypes.UNLINK_PAYMENT.LOADING, {
    unLinkPaymentLoading,
  },
  );

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  updatePaymentOutgoingStatus = (payload, callback) => action(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updatePaymentOutgoingStatusLoading
   * @returns {{type: *}}
   */
  updatePaymentOutgoingStatusLoading = (updatePaymentOutgoingStatusLoading) => action(
    paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.LOADING, {
    updatePaymentOutgoingStatusLoading,
  },
  );

  /**
   * @param {*} payload
   * @param grnPaymentId
   * @param {*} callback
   * @return
   */
  updatePaymentOutgoingWorkflow = (payload, callback) => action(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updatePaymentOutgoingWorkflowLoading
   * @returns {{type: *}}
   */
  updatePaymentOutgoingWorkflowLoading = (updatePaymentOutgoingWorkflowLoading) => action(
    paymentActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.LOADING, {
    updatePaymentOutgoingWorkflowLoading,
  },
  );

  // unlink PO advance payment

  unlinkPOAdvancePayment = (payload, callback) => action(paymentActionTypes.UNLINK_PO_ADVANCE_PAYMENT.REQUEST, {
    payload,
    callback,
  });

  unlinkPOAdvancePaymentLoading = (unlinkPOAdvancePaymentLoading) => action(
    paymentActionTypes.UNLINK_PO_ADVANCE_PAYMENT.LOADING, {
    unlinkPOAdvancePaymentLoading,
  },
  );

  // download payment outgoing
  downloadPaymentOutgoing = (payload, callback) => action(paymentActionTypes.DOWNLOAD_PAYMENT_OUTGOING.REQUEST, {
    payload,
    callback,
  });

  downloadPaymentOutgoingLoading = (downloadPaymentOutgoingLoading) => action(
    paymentActionTypes.DOWNLOAD_PAYMENT_OUTGOING.LOADING, {
    downloadPaymentOutgoingLoading,
  },
  );
}

export default new PaymentOutgoingActions();
